import { Paginator, SortDirection } from '@app/classes';
import { AssignedDentalBenefitEmployee } from '@app/models/payroll/assigned-dental-benefit-employee.model';
import { Table } from '@app/modules/table/classes/table.class';
import { MenuColumnItem } from '@app/modules/table/interfaces/menu-column-item.interface';
import { AuthService } from '@app/services';
import { DentalBenefitCode } from '../../dental-benefit/types';
import columns from './columns';

export class DentalBenefitsAssignedTable extends Table<AssignedDentalBenefitEmployee> {
    sortDirection = SortDirection.ASC;
    showMenuColumnOptions = true;

    constructor(
        protected authService: AuthService,
        private benefitCode: DentalBenefitCode
    ) {
        super(authService);
        this.boot();
    }

    setColumns(): void {
        this.columns = columns.map((DentalBenefitsAssignedColumn) => new DentalBenefitsAssignedColumn());
    }

    setDataSource(): void {
        this.paginator = new Paginator(
            AssignedDentalBenefitEmployee.param('company', this.authService.company.id)
                .where('option', this.benefitCode)
                .with(['job', 'status'])
        );
    }

    getMenuColumnOptionsForRow(_: AssignedDentalBenefitEmployee): MenuColumnItem[] {
        return [{ label: 'remove', event: 'revoke' }];
    }
}
